const sidebar = {
    bg: `contentBg`,
    borderRadius: `full`,
    transition: `
      transform 250ms ease,
      box-shadow 250ms ease,
      color 250ms ease
    `,
    px: [3, 4],
    py: [3, 4],
    display: `flex`,
    flexDirection: `column`
  }
  
  export default sidebar